var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePageContainer',{staticClass:"pt-10"},[_c('PageHeader',{attrs:{"has-back":"","with-members":""}},[_vm._v(" 身長体重管理 ")]),_c('BodyMeasurementsForm',{ref:"form",on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }